<ng-template #content>
  <div class="lna-modal-header">
    <div class="modal-title-with-tooltip">
      <h4 class="modal-title" ngbAutofocus>{{ 'pages.viewInfoRequest.invoice.markPaidModal.title' | translate }}</h4>
      <app-tooltip text="invoiceMarkPaid" />
    </div>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <form [formGroup]="form">
      <div class="lna-row-32 full-width">
        <p class="field-label-bold">{{ 'pages.viewInfoRequest.invoice.markPaidModal.serviceExecutionDeadline' | translate }}</p>
        <p class="field-value">{{ serviceExecutionDeadlineLabel }}</p>
      </div>
      <div class="lna-row-32 full-width mt-16">
        <label class="form-label lna">
          {{ 'pages.viewInfoRequest.invoice.markPaidModal.mustCompleteByDate' | translate }}
        </label>
        <app-date-picker
          [date]="form.get('mustCompleteByDate')?.value"
          [dateRangeMode]="DateRangeMode.FutureAndToday"
          (dateSelected)="onDateSelected($event)" />
        <p class="field-value">{{ 'pages.viewInfoRequest.invoice.markPaidModal.note' | translate }}</p>
      </div>
    </form>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="isLoading" (click)="confirm()">
      {{ 'pages.viewInfoRequest.invoice.markPaidModal.confirm' | translate }}
    </button>
    <button class="secondary" (click)="close()">
      {{ 'pages.viewInfoRequest.invoice.cancel' | translate }}
    </button>
  </div>
</ng-template>
